<div class="layout-sidebar">
    <a [routerLink]="['/']" class="app-logo">
        <img src="assets/images/logo.svg" width="124" height="auto" class="app-logo-normal">
        <img src="assets/images/logo.svg" width="21" height="auto" class="app-logo-small">
    </a>

    <div class="layout-menu-container">
        <app-menu></app-menu>
    </div>
</div>